export default __webpack_public_path__ + "static/media/ButtonHelp.2493d472.png";